module.exports = __webpack_public_path__ + "img/product6.79392394.png";